module.exports = __webpack_public_path__ + "static/media/whatfoxsay.6140cd91.mp3";